import Afifi from "../../assets/home/afifi.webp";
import Nagi from "../../assets/home/nagi.jpg";
import Hana from "../../assets/home/hana.jpg";
import Jen from "../../assets/home/jen.jpg";
import styles from "./Team.module.css";

const Team = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.teamContainer}>
          <h3>فريقنا</h3>
          <div className={styles.memberContainer}>
            <div className={styles.teamMember}>
              <img src={Afifi} alt="Mohamed Afifi" />
              <h4>Mohamed Afifi</h4>
              <p>الرئيس</p>
            </div>
            <div className={styles.teamMember}>
              <img src={Nagi} alt="Dr. Mohamed Nagi" />
              <h4>Dr. Mohamed Nagi</h4>
              <p>نائب الرئيس</p>
            </div>
            <div className={styles.teamMember}>
              <img src={Hana} alt="Dr. Hana Bali" />
              <h4>Dr. Hana Bali</h4>
              <p>مدير التدريب والخدمات الفنية</p>
            </div>
            <div className={styles.teamMember}>
              <img src={Jen} alt="EN WEI" />
              <h4>JEN WEI</h4>
              <p>وكيلنا في الصين </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Team;
